<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title="'挥剑问情丨马上逍遥h5活动'"></div>
    <div class="home-wrapper-3">
      <div class="springFestival-home-page" id="springFestival-home-page">
        <div class="main">
          <div class="container">
            <div class="swiper-bg">
              <div class="swiper-bg-warp">
                <!-- 禁用鼠标拖动swiper-no-swiping -->
                <div class="swiper-wrapper swiper-no-swiping">
                  <div class="swiper-slide">
                    <div class="content-box">
                      <div class="top-left-info-box">
                        <div class="server_name">
                          {{ userInfo.role_name }} {{ userInfo.server_name }}
                        </div>
                        <div class="osBtn" :class="userInfo.role_id ? 'logout' : 'login'" @click="openLoginOS($event)">
                          {{ osBtn }}
                        </div>
                      </div>
                      <div class="top-right-btn-box">
                        <div class="btn" :class="[
                          isShowMusicBtn ? 'music-btn' : 'music-pause-btn',
                          { 'btn-scale-ani': isBtnScaling }
                        ]" @click="musicClick(!isShowMusicBtn, $event)">
                        </div>
                        <!-- <div class="btn music-btn" v-if="isShowMusicBtn" @click="musicClick(false, $event)"></div>
                        <div class="btn music-pause-btn" v-if="!isShowMusicBtn" @click="musicClick(true, $event)"></div> -->
                        <div class="btn detail-btn" @click="openDetailPop($event)"></div>
                      </div>
                      <div class="bottom-left-btn-box">
                        <div class="reward-list-btn" @click="openRewardList($event)"></div>
                        <div class="qdyz-btn" @click="openTaskList($event)"></div>
                      </div>
                      <div class="lantern"></div>
                      <!-- 左景 -->
                      <div class="dec-bg">
                        <div ref="dec-lantern" class="dec-lantern" :class="[{ lanternAni: lanternAni }]"
                          @animationend="lanternAni = false" @click="lanternClick($event)">
                          <div class="lantern-inner"></div>
                        </div>
                      </div>
                      <!-- 背景人物彩蛋 -->
                      <div class="bg-role-egg-box">
                        <div class="bg-tyr" @click="clickTyrEgg()"></div>
                        <div class="bg-lxy"></div>
                        <div class="lsmr" :class="{ lsmrAni: eggAniList.lsmr }"></div>
                        <div class="lsmr-02" @click="playClickAni('lsmr', 1000, 'bumpMusic')"></div>
                        <div class="qms" :class="{ qmsAni: eggAniList.qms }"
                          @click="playClickAni('qms', 1000, 'dogMusic')"></div>
                        <div class="blr" :class="{ blrAni: eggAniList.blr }"></div>
                        <div class="blr-02" @click="playClickAni('blr', 1000, 'fallMusic')"></div>
                        <div class="qycs" :class="{ qycsAni: eggAniList.qycs }"
                          @click="playClickAni('qycs', 1000, 'sweepMusic')"></div>
                      </div>
                      <!-- 转盘 -->
                      <div class="compass-ani-box" :style="compassZIndexStyle">
                        <!-- 外盘 + 8 个格子 -->
                        <div class="compass-box" :class="{ 'turntable-hit': isHit }">
                          <div class="compass" :class="[compassClass]" @animationstart="onAnimationStart"
                            @animationend="handleAnimationEnd">
                            <div class="compass-slots">
                              <div v-for="(item, index) in slotList" :key="index"
                                :class="`compass-slot compass-slot-${index + 1}`">
                                <div class="slot-highlight" v-show="index === activeSlotIndex && showHighlight"></div>
                              </div>
                            </div>
                          </div>
                          <!-- 中心转轴：猫 + 箭头（整块当作指针） -->
                          <div class="compass-pointer" :class="`pointer-${pointerState}`" :style="pointerStyle"></div>
                        </div>
                        <div class="lxy" :class="{ 'lxy-active': lxyAni }" v-show="lxyAni"></div>
                        <img class="lxy-02" :src="lxyAni02Img" v-show="lxyAni02" alt="gourd" />
                        <!-- <div class="lxy-02" :class="{ 'lxy02-active': lxyAni02 }" v-show="lxyAni02"></div> -->
                        <transition name="white-fade">
                          <div class="lxy-white-wrap" v-show="lxyWhitePop"></div>
                        </transition>
                        <transition name="light-fade">
                          <div class="sword-light" v-show="lightShow"></div>
                        </transition>
                      </div>
                      <!-- 核心奖励弹窗 -->
                      <div class="core-reward-box" v-if="corePopShow"></div>
                      <div class="ani_box">
                        <div class="firework_01"></div>
                        <div class="firework_02"></div>
                        <div class="firework_03"></div>
                        <div class="firework_04"></div>
                        <div class="firework_05"></div>
                        <div class="firework_06"></div>
                      </div>
                      <div class="gourd-box">
                        <div class="green-gourd" :class="{ 'green-gourd-active': showGreenGourd }"></div>
                        <div class="drink-count">
                          <div class="gourd-count" :class="{ 'gourd-icon-leave': isDecreasing }">
                            <img class="gourd-icon" :src="gourdIcon" alt="gourd" />
                            <span class="gourd-text">x{{ drinkTimes }}</span>
                          </div>
                        </div>
                        <div class="start-btn" :class="{ 'shakeAni': isShake }" @touchstart="unlockDingOnIOS()"
                          @click="handleClick($event)">
                          <div class="start-btn-inner"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 预加载 -->
        <div id="preloading" :class="[isShow ? 'show' : '', sceneState]" v-show="isShowLoading">
          <div key="scene-01" class="scene-01">
            <div class="lxy"></div>
            <div class="role-01"></div>
            <div class="role-02"></div>
            <div class="role-03"></div>
            <div class="role-04"></div>
            <div class="right-cloud"></div>
            <div class="bottom-progress-box">
              <div class="content-text">
                正在友好邀请反派们回府过节
                <!-- 正在友好邀请反派们回府过节 {{ preloadProgress }}% -->
                <div class="dots"><span>.</span><span>.</span><span>.</span></div>
              </div>
              <div class="progress-box">
                <div class="progress-bar">
                  <span :style="{ width: preloadProgress + '%' }"></span>
                </div>
              </div>
            </div>
          </div>

          <div key="scene-02" class="scene-02">
            <div class="lxy">
              <div class="dec-icon"></div>
            </div>
            <div class="front-mountain"></div>
            <div class="role-01-head"></div>
            <div class="enter-btn" @click="enterHome($event)">
              <div class="enter-inner"></div>
            </div>
          </div>
        </div>

        <!-- 注销弹窗 -->
        <div class="logout-wrap-hjwq popup_wrap1" v-show="logoutShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="popup-wrap-box-hjwq" v-show="logoutShow">
              <h2>确定退出当前用户</h2>
              <div>
                <a href="javascript:;" @click="logoutShow = false">取消</a>
                <a href="javascript:;" @click="logout()">确认</a>
              </div>
            </div>
          </transition>
        </div>

        <!-- 赠礼记录 -->
        <div class="reward-list-wrap popup_wrap1" v-show="rewardListPop">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div>
              <div class="reward-box popup_wrap-box" v-show="rewardListPop">
                <div class="lantern lantern-01"></div>
                <div class="lantern lantern-02"></div>
                <div class="list-wrap">
                  <div class="reward-list-box">
                    <div class="reward-item" v-for="(item, index) in rewardList" :key="index"
                      :class="{ 'limit-item': item.prop_id == '9' }">
                      <div class="left-reward" :class="`reward-0${item.prop_id}`"></div>
                      <div class="right-time">{{ item.updated_at }}</div>
                    </div>
                  </div>
                </div>
                <div class="close-btn" @click="closeRewardListPop"></div>
              </div>
            </div>
          </transition>
        </div>

        <!-- 任务页 -->
        <div class="task-list-wrap popup_wrap1" v-show="taskListPop">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div>
              <div class="task-box popup_wrap-box" v-show="taskListPop">
                <div class="lantern lantern-01"></div>
                <div class="lantern lantern-02"></div>
                <div class="task-list">
                  <li class="task-item" v-for="(item, index) in taskList" :key="index">
                    <div class="info">
                      <span>{{ item.title }}</span>
                      <span v-if="item.task_id == 3">（{{ item.count }}/3）</span>
                    </div>
                    <div class="icon" :class="`icon-${item.task_id == 3 ? '01' : '02'}`"></div>
                    <div class="btn">
                      <a :class="`task-0${item.task_id}-${item.is_get && item.count == item.total_number}-btn`"
                        href="javascript:;"
                        @click="participatingTask(item.task_id, $event, item.is_get && item.count == item.total_number)"></a>
                    </div>
                  </li>
                </div>
                <div class="close-btn" @click="closeTaskListPop"></div>
              </div>
            </div>
          </transition>
        </div>

        <!-- 详情弹窗 -->
        <div class="detail-wrap popup_wrap1" v-show="detailPop">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div>
              <div class="detail-box popup_wrap-box" v-show="detailPop">
                <div class="lantern lantern-01"></div>
                <div class="lantern lantern-02"></div>
                <div class="close-btn" @click="closeDetailPop()"></div>
              </div>
            </div>
          </transition>
        </div>

        <!-- 转盘弹窗 -->
        <div class="compass-reward-wrap popup_wrap1" v-show="compassRewardPop">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div>
              <div class="reward-box popup_wrap-box" v-show="compassRewardPop">
                <div class="lantern lantern-01"></div>
                <div class="lantern lantern-02"></div>
                <div class="reward" :class="`reward-0${targetIndex}`"></div>
                <div class="confirm-btn" @click="closeRewardPop()"></div>
              </div>
            </div>
          </transition>
        </div>

        <!-- 转盘弹窗-核心奖励 -->
        <div class="compass-reward-limited-wrap popup_wrap1" v-show="compassRewardLimitPop">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div>
              <div class="reward-box popup_wrap-box" v-show="compassRewardLimitPop">
                <div class="lantern lantern-01"></div>
                <div class="lantern lantern-02"></div>
                <div class="reward"></div>
                <div class="ns"></div>
                <div class="confirm-btn" @click="closeRewardLimitPop"></div>
              </div>
            </div>
          </transition>
        </div>

        <!-- 唐雨柔彩蛋弹窗 -->
        <div class="tyr-egg-wrap popup_wrap1" v-show="tyrEggPop">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div>
              <div class="egg-box popup_wrap-box" v-show="tyrEggPop">
                <div class="lantern lantern-01"></div>
                <div class="lantern lantern-02"></div>
                <div class="egg-text" @click="onCopyEgg()" id="clipboard-egg-btn" data-event="复制唐雨柔彩蛋文字密令"
                  :data-clipboard-text="'多喜乐长安宁'"></div>
                <p class="tips">点击密令复制</p>
                <div class="confirm-btn" @click="closeTyrEggPop"></div>
              </div>
            </div>
          </transition>
        </div>

        <!-- 灯笼彩蛋弹窗（cdk） -->
        <div class="lantern-egg-wrap popup_wrap1" v-show="lanternEggPop">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div>
              <div class="cdk-box popup_wrap-box" v-show="lanternEggPop">
                <div class="lantern lantern-01"></div>
                <div class="lantern lantern-02"></div>
                <p class="cdk" @click="onCopyCDK()" id="clipboard-cdk-btn" data-event="复制CDK"
                  :data-clipboard-text="`${egg_cdk}`">{{ egg_cdk }}</p>
                <p class="tips">点击兑换码复制</p>
                <div class="confirm-btn" @click="closeLanternEggPop"></div>
              </div>
            </div>
          </transition>
        </div>

        <!-- 非微信下的邀请好友弹窗 -->
        <div :class="'invite-friends-wrap popup_wrap1 invite-friends-wrap-' + inviteFriendsShow"
          v-show="inviteFriendsShow">
          <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"
            :duration="{ enter: 1000 }">
            <div class="invite-friends-box popup_wrap-box" v-show="inviteFriendsShow">
              <div class="lantern lantern-01"></div>
              <div class="lantern lantern-02"></div>
              <div class="invite-btn" @click="onCopy()" id="clipboard-btn" data-event="复制邀请链接"
                :data-clipboard-text="`《挥剑问情》一贫道人已备好新春赠礼，请侠友赠我一壶桂花酿，助我拿下重宝：https://h5.qingcigame.com/hjwq/springFestival/enter?friend_id=${userInfo.user_id}`">
              </div>
              <div class="close-btn" @click="closeInvitePop()"></div>
            </div>
          </transition>
        </div>

        <!-- 微信分享引导弹窗 -->
        <div :class="'share-wrap popup_wrap1 share-wrap-' + shareShow" v-show="shareShow">
          <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"
            :duration="{ enter: 1000 }">
            <div class="share-img popup_wrap-box" v-show="shareShow" @click="closeSharePop()"></div>
          </transition>
        </div>

        <!-- 助力弹窗 -->
        <div :class="'help-friends-wrap popup_wrap1 help-wrap-' + helpShow" v-show="helpShow">
          <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"
            :duration="{ enter: 1000 }">
            <div class="help-box popup_wrap-box" v-show="helpShow">
              <div class="lantern lantern-01"></div>
              <div class="lantern lantern-02"></div>
              <div class="accept-btn" @click="acceptInvitationBtn()"></div>
              <div class="close-btn" @click="closeHelpPop()"></div>
            </div>
          </transition>
        </div>

        <!-- 气泡弹窗 -->
        <div :class="`toast-message-wrap toast-${toastShow}`" v-show="toastShow" @click.stop>
          <div class="toast-box popup_wrap-box" v-show="toastShow">
            {{ toastMessage }}
          </div>
        </div>
      </div>

      <!-- 登陆模块 -->
      <Login v-if="isShowLogin" v-on:channelCallback="selectCallback" :gameName="gameName" :loginTypes="loginTypes"
        downloadUrl="https://hjwq.qingcijoy.com/" channelTips="UID可在游戏中—设置—UID查看" noAuthLogin></Login>
      <Os v-if="isShowOs" v-on:selectCallback="selectCallback" v-on:logoutCallback="osCancell" :gameName="gameName">
      </Os>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import { Toast, Indicator } from 'mint-ui';
import Os from "../os";
import Login from "../login";
import { mapState, mapMutations, mapActions } from "vuex";
import { onGetInitDataAPI, lotteryDataAPI, onGetCdkAPI, assistanceDataAPI, onLogoutAPI, onGetFreeLoginAPI } from "../api";
import { buriedLogger, getRandomString, wechatBrowser } from "@/utils/utils";
import "../../../../assets/js/jsmpeg";

import Vconsole from "vconsole";

export default {
  components: {
    Login,
    Os,
  },
  data () {
    return {
      gameName: "hjwq",
      logger: null,
      // 其他数据
      loginTypes: ["sms", "password", "channel"],
      active_Info: {},
      user_info: {},
      osBtn: '',
      logoutShow: false,
      swiper: null,
      // 是否显示预加载弹窗
      isShowLoading: true,
      isShow: false,
      // 预加载页两种显示场景
      sceneState: 'state-01', // 初始显示第一屏
      //是否是平板
      isTablet: false,
      // 是否显示音乐按钮
      isShowMusicBtn: true,
      isBtnScaling: false,
      // 横屏长一点的手机
      isLong: false,
      timer: null,
      preloadProgress: 0,

      // `````````````````````````````````````````````
      // 转盘翻转动画（控制年兽状态）
      pointerTimer: null,
      totalFrames: 15,
      targetFrame: 12,
      duration: 0.5,

      isShake: true, // 葫芦是否在晃动
      isFront: true,      // 当前是否是正面

      // 盘面状态
      isFrontNow: true,      // 当前是正面(true)还是反面(false)
      isFlipping: false,    // 是否在做 180° 翻转
      isAnimating: false, // 是否正在整轮动画流程中（禁止点击）
      compassClass: '',    // 当前附加在 .compass 上的动画类 '', 'compass-forward', 'compass-backward'

      // 次数 & 葫芦动画
      drinkTimes: 0,
      isDecreasing: false,
      gourdIcon: require('../../../../assets/images/active/hjwq/springFestival/xhl.png'),
      showGreenGourd: false, // 核心奖励绿葫芦

      // 李逍遥
      lxyAni: false,
      lightShow: false,
      corePopShow: false, // 核心奖励黑色背景图层
      isHit: false, // 转盘是否被剑砍
      lxyAni02: false,
      lxyAni02Img: require('../../../../assets/images/active/hjwq/springFestival/lxy_ani_02_apng.png'),
      lxyWhitePop: false,

      // 彩蛋
      lanternClickCount: 0,
      lanternAni: false,
      isLanternScaling: false,
      egg_cdk: '',
      // 各点位动画开关（控制 class）
      eggAniList: {
        // lantern: false,
        lsmr: false,
        qms: false,
        blr: false,
        qycs: false,
      },

      // 各点位定时器（防止重复点击 & 到点复原）
      eggAniTimersList: {
        // lantern: null,
        lsmr: null,
        qms: false,
        blr: false,
        qycs: false,
      },

      // 音乐相关
      audioPlayers: {},
      audioMap: {
        bgMusic: require('@/assets/images/active/hjwq/springFestival/mp3/bg_loop_music.mp3'), // 背景
        lxyMusic: require('@/assets/images/active/hjwq/springFestival/mp3/lxyMusic.mp3'), // 李逍遥旁白
        btnMusic: require('@/assets/images/active/hjwq/springFestival/mp3/clickBtnMusic.mp3'), // 按钮
        swordMusic: require('@/assets/images/active/hjwq/springFestival/mp3/sword.mp3'), // 剑砍声
        pointerMusic: require('@/assets/images/active/hjwq/springFestival/mp3/pointerMusic.mp3'), // 指针转动
        dingMusic: require('@/assets/images/active/hjwq/springFestival/mp3/dingMusic.mp3'), // 指针叮叮叮声

        bumpMusic: require('@/assets/images/active/hjwq/springFestival/mp3/bumpMusic.mp3'), // 蓝色魔人
        dogMusic: require('@/assets/images/active/hjwq/springFestival/mp3/dog.mp3'), // 千面兽
        fallMusic: require('@/assets/images/active/hjwq/springFestival/mp3/fall.mp3'), // 半龙人
        sweepMusic: require('@/assets/images/active/hjwq/springFestival/mp3/sweep.mp3'), // 千叶禅师
        nianMusic: require('@/assets/images/active/hjwq/springFestival/mp3/nian.mp3'), // 转盘年兽
        redeemMusic: require('@/assets/images/active/hjwq/springFestival/mp3/redeem.mp3'), // 转盘指针最终定位
      },

      // ===== WebAudio SFX(音效/旁白) 管理 =====
      sfx: {
        ctx: null,
        masterGain: null,
        buffers: Object.create(null), // name -> AudioBuffer
        unlocked: false,
        ready: false,
        loading: false,
        // 你可以只预加载核心奖励相关，别一次性全塞进来
        preloadList: [
          'swordMusic',
          'nianMusic',
          'redeemMusic',
          'lxyMusic',
        ],
        // 全局音效音量（不含 bgm）
        volume: 1,
      },

      // 背景音乐淡入淡出控制
      _bgmFadeRaf: null,

      // 大尺寸图片相关
      compassImg: require('@/assets/images/active/hjwq/springFestival/compass_ani.png'),
      coreLxyImg: require('@/assets/images/active/hjwq/springFestival/lxy_ani.png'),
      coreLxy02Img: require('@/assets/images/active/hjwq/springFestival/lxy_ani.png'),

      // 叮声控制
      lastDingIndex: -1,
      lastDingAt: 0,
      dingMinGap: 90,     // iOS 建议 80~120ms（太小会卡/丢）

      // ⭐ ding 音效池（新增）
      dingAudios: [],
      dingAudioIndex: 0,
      dingPoolSize: 8,

      highlightAngleFix: 0,

      userMutedBgm: false, // 标记用户是否主动关闭过背景音乐

      // 槽位（8 个）
      slotList: [
        { text: '金龙' },
        { text: '1星符文随机包' },
        { text: '古宝随机包' },
        { text: '五系招募石' },
        { text: '映朝花' },
        { text: '祈愿符' },
        { text: '至尊召唤券' },
        { text: '洗练石' }
      ],

      rewardList: [],
      taskList: [],

      // 抽中的奖励
      targetIndex: 0,  // 1~8：普通 9：核心奖励

      // 指针状态
      pointerState: 0, //年兽指针状态 0：无 1：常态 2：被砍
      isSpinning: false,     // 是否正在转（禁止重复点击）
      prizeCount: 8,         // 槽位数
      sectorAngle: 360 / 8,  // 每格 45 度
      baseOffset: 0,
      pointerOffset: 0,      // 让 index=0 正中时的基础偏移
      pointerStyle: {
        transform: 'translate(-50%, -50%) rotate(0deg)',
      },
      compassZIndexStyle: {
        zIndex: '2'
      },

      // 指针当前角度（运行时更新）
      currentAngle: 0,        // 动画中瞬时角度（用来算光圈）
      finalAngle: 0,          // 本次动画的终点角度

      activeSlotIndex: -1,  // 当前高亮的格子索引，-1 表示没有高亮
      showHighlight: true,  // ⭐ 光圈是否显示
      spinTimer: null,       // 控制高亮跳动的定时器
      runningStep: 0,   // 旋转过程中用来驱动光圈的“当前步”

      isLimitReward: false, // 是否是核心奖励

      // 弹窗
      toastShow: false, // 气泡弹窗
      toastMessage: '', // 气泡弹窗内容
      toastTime: 0, // 气泡弹窗时间

      detailPop: false, // 详情
      compassRewardPop: false,
      compassRewardLimitPop: false, // 核心奖励
      rewardListPop: false, // 奖励记录
      taskListPop: false, // 任务页
      inviteFriendsShow: false, // 邀请好友
      helpShow: false, // 被邀请

      // 分享弹窗
      shareShow: false,
      shareImg: "",

      // 彩蛋弹窗
      tyrEggPop: false,
      lanternEggPop: false,

      _uidMark: Math.random().toString(36).slice(2),  // 调试用
    };
  },
  created () {
    this.preloading();

    // 获取url上的参数
    const urlParams = new URLSearchParams(window.location.search);
    this.friendId = urlParams.get('friend_id');
    this.urlToken = urlParams.get('token');
    this.cachedToken = localStorage.getItem("hjwq_sf_token");

    urlParams.delete('token');
    urlParams.delete('friend_id');

    const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
    window.history.replaceState(null, '', newUrl);

    // 清空store上的用户数据
    setTimeout(() => {
      this.setInitActiveInfo();
      this.setInitUserInfo();
    }, 100)
    this.isSetShare();

    // 埋点
    const bl = buriedLogger("hjwq", "仙剑_春节转盘");
    this.logger = bl;

    const ua = navigator.userAgent;
    const isAndroid = /(?:Android)/.test(ua);
    const isFireFox = /(?:Firefox)/.test(ua);
    this.isTablet =
      /(?:iPad|PlayBook)/.test(ua) ||
      (isAndroid && !/(?:Mobile)/.test(ua)) ||
      (isFireFox && /(?:Tablet)/.test(ua));
  },
  mounted () {
    this.$nextTick(() => {
      this.forceLandscapeScreenHandle();
      this.onWindowSizeChanged();
      this.startLoading();

      // ⭐ 初始化 ding 音效池
      this.initDingPool();

      const bl = buriedLogger('hjwq', '仙剑_春节h5');  // 埋点
      this.logger = bl;
      setTimeout(() => {
        this.logger.sum('仙剑_春节h5_活动页统计');
      }, 200);
    });
    // new Vconsole();
  },
  computed: {
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"]),
  },
  watch: {
    userInfo: {
      async handler (newValue, oldValue) {
        this.updateOsBtn();

        if (!newValue.user_id && oldValue.user_id) {
          // TAG: 注销的时候

        } else if (newValue.user_id !== oldValue.user_id) {
          // TAG: 初始登陆/切换角色的时候
          this.friendHelp();
        }
      },
    }
  },
  methods: {
    isIOS () {
      return /iP(hone|od|ad)/.test(navigator.userAgent);
    },
    updateOsBtn () {
      if (this.userInfo.role_id) {
        this.userInfo.platform === 'android' || this.userInfo.platform === 'ios'
          ? this.osBtn = '切换'
          : this.osBtn = '注销'
      } else {
        this.osBtn = '登录'
      }
    },
    onToastMessage (message, time) {
      this.toastTime = time || 2000;
      this.toastShow = true;
      this.toastMessage = message;
      setTimeout(() => {
        this.toastShow = false;
        this.toastMessage = '';
        this.toastTime = 0;
      }, this.toastTime);
    },
    // 通用按钮缩放动画
    // triggerBtnScale (e) {
    //   const el = e.currentTarget;
    //   el.classList.add('btn-scale-ani');
    //   // this.preventShow = true;
    //   el.addEventListener('animationend', function handler () {
    //     el.classList.remove('btn-scale-ani');
    //     el.removeEventListener('animationend', handler);
    //   });
    //   setTimeout(() => { this.preventShow = false }, 250);
    // },
    // 特殊处理按钮缩放动画
    triggerBtnScale (e) {
      const el = e.currentTarget
      el.classList.remove('btn-scale-ani')
      void el.offsetWidth // 强制重绘，保证能重新触发动画
      el.classList.add('btn-scale-ani')

      el.addEventListener('animationend', function handler () {
        el.classList.remove('btn-scale-ani')
        el.removeEventListener('animationend', handler)
      })
    },
    // 预加载
    preloading () {
      const interval = setInterval(() => {
        if (this.preloadProgress >= 100) {
          clearInterval(interval);
          // 场景切换
          this.gotoScene02();
        } else {
          this.preloadProgress += 1
        }
      // }, 4);
      }, 40);
    },
    gotoScene02 () {
      // 开始动画
      this.sceneState = 'state-anim'
      // 动画结束后定格在第二屏
      setTimeout(() => {
        this.sceneState = 'state-02'
      }, 1000) // 和 CSS 里的过渡时间保持一致
    },
    enterHome (e) {
      // this.triggerBtnScale(e);
      const inner = e.currentTarget.querySelector('.enter-inner')
      inner.classList.remove('btn-scale-ani') // 先移除，保证连点也能重新触发
      // 强制重绘，让浏览器认为是一次新的动画
      void inner.offsetWidth
      inner.classList.add('btn-scale-ani')

      inner.addEventListener('animationend', function handler () {
        inner.classList.remove('btn-scale-ani')
        inner.removeEventListener('animationend', handler)
      })

      this.playAudio('btnMusic');
      // 用户点击后解锁 WebAudio，并后台预加载核心奖励音效
      this.unlockSfxAudio().then(() => {
        // 不要阻塞首屏，延迟一点更稳
        setTimeout(() => this.preloadSfxAudio(), 600);
      });
      this.initWebAudioDing();

      if (this.urlToken) {
        // 免密登录
        onGetFreeLoginAPI({ token: this.urlToken }).then((response) => {
          if (Number(response.code) == 200) {
            this.access_token = response.data.access_token;
            localStorage.setItem('hjwq_sf_token', this.urlToken);
            // 初始化
            this.getLoginContainer();
          } else {
            this.onToastMessage(response.message);
            this.clearActiveInfo();
            localStorage.clear();
          }
        })
      } else {
        this.getLoginContainer();
      }


      setTimeout(() => {
        this.isShow = true;
        this.isShowLoading = false;
        this.playAudioBg('bgMusic');
      }, 500);
      this.logger.sum('仙剑_春节h5_点击举杯共饮按钮');

      setTimeout(() => {
        // 首屏稳定后后台预解码（建议 300~800ms 后）
        this.preloadCoreAssets();
      }, 300);
    },
    // 先预加载图片
    preloadAndDecode (url) {
      return new Promise((resolve) => {
        const img = new Image();

        img.onload = () => resolve(url);
        img.onerror = () => resolve(url); // 失败也 resolve，避免卡住整体流程

        img.src = url;

        // 关键：decode 让浏览器提前解码，避免首次显示卡顿
        if (img.decode) {
          img.decode().then(() => resolve(url)).catch(() => resolve(url));
        }
      });
    },

    async preloadCoreAssets () {
      // 这里填“核心奖励阶段一定会用到”的大图（人物/剑光/指针/黑底等）
      const urls = [
        // 示例：如果你的图是 import/require 出来的，这里直接放变量
        this.compassImg,
        this.coreLxyImg,
        this.lxyAni02Img,
        this.coreLxy02Img,
      ].filter(Boolean);

      await Promise.all(urls.map(u => this.preloadAndDecode(u)));
    },

    /* =========================
     * 1) WebAudio 解锁（必须用户手势触发）
     * ========================= */
    async unlockSfxAudio () {
      if (this.sfx.unlocked) return true;

      const AudioContext = window.AudioContext || window.webkitAudioContext;
      if (!AudioContext) return false;

      if (!this.sfx.ctx) {
        this.sfx.ctx = new AudioContext();
        this.sfx.masterGain = this.sfx.ctx.createGain();
        this.sfx.masterGain.gain.value = this.sfx.volume;
        this.sfx.masterGain.connect(this.sfx.ctx.destination);
      }

      // iOS/Safari 经常 suspended
      if (this.sfx.ctx.state === 'suspended') {
        try { await this.sfx.ctx.resume(); } catch (e) { }
      }

      // 播放一个空 buffer 作为“解锁确认”
      try {
        const buffer = this.sfx.ctx.createBuffer(1, 1, 22050);
        const src = this.sfx.ctx.createBufferSource();
        src.buffer = buffer;
        src.connect(this.sfx.masterGain);
        src.start(0);
        this.sfx.unlocked = true;
        return true;
      } catch (e) {
        return false;
      }
    },

    /* =========================
     * 2) 拉取+解码单个音效（WebAudio）
     * ========================= */
    async loadSfxBuffer (name) {
      if (!name) return null;
      if (this.sfx.buffers[name]) return this.sfx.buffers[name];

      const url = this.audioMap && this.audioMap[name];
      if (!url) return null;

      // 确保 ctx
      await this.unlockSfxAudio();
      if (!this.sfx.ctx) return null;

      const resp = await fetch(url, { cache: 'force-cache' });
      const arrBuf = await resp.arrayBuffer();

      // 兼容 Safari 的 decodeAudioData（有的还是回调）
      const audioBuffer = await new Promise((resolve, reject) => {
        try {
          const p = this.sfx.ctx.decodeAudioData(
            arrBuf,
            (buf) => resolve(buf),
            (err) => reject(err)
          );
          if (p && p.then) p.then(resolve).catch(reject);
        } catch (e) {
          reject(e);
        }
      });

      this.sfx.buffers[name] = audioBuffer;
      return audioBuffer;
    },

    /* =========================
     * 3) 预加载（核心奖励需要的那批）
     * ========================= */
    async preloadSfxAudio (list) {
      if (this.sfx.loading || this.sfx.ready) return;

      this.sfx.loading = true;
      const names = (list && list.length ? list : this.sfx.preloadList).filter(Boolean);

      try {
        await this.unlockSfxAudio();
        // 解锁失败就不强求（仍可走 <audio> fallback）
        if (!this.sfx.ctx) return;

        await Promise.all(names.map(n => this.loadSfxBuffer(n).catch(() => null)));
        this.sfx.ready = true;
      } finally {
        this.sfx.loading = false;
      }
    },

    /* =========================
     * 4) 播放音效/旁白（优先 WebAudio，失败 fallback 到 <audio>）
     * ========================= */
    playSfx (name, { volume = 1 } = {}) {
      // 你原本的“音效开关”逻辑可以统一控制：关了就全部不播
      // 如果你只想控制 bgm，不控制 sfx，就把这行去掉
      if (!this.isShowMusicBtn) return;

      // WebAudio 可用
      const buf = this.sfx.buffers[name];
      if (this.sfx.ctx && buf && this.sfx.ctx.state === 'running') {
        const src = this.sfx.ctx.createBufferSource();
        src.buffer = buf;

        const gain = this.sfx.ctx.createGain();
        gain.gain.value = Math.max(0, Math.min(1, volume));

        src.connect(gain);
        gain.connect(this.sfx.masterGain);
        src.start(0);
        return;
      }

      // fallback：用你原来的 Audio 标签播放（兼容，但第一次可能会卡）
      this.playAudioFallback(name);
    },

    /* =========================
     * 5) 兼容 fallback：保留你原来的 Audio 播放方式
     * ========================= */
    playAudioFallback (audioName) {
      if (!audioName) return;

      if (!this.audioPlayers[audioName]) {
        this.audioPlayers[audioName] = new Audio(this.audioMap[audioName]);
        this.audioPlayers[audioName].loop = false;
      }
      const audio = this.audioPlayers[audioName];
      try {
        audio.pause();
        audio.currentTime = 0;
      } catch (e) { }
      const p = audio.play();
      if (p && p.catch) p.catch(() => { });
    },
    initDingPool () {
      if (this.dingAudios.length) return;
      for (let i = 0; i < this.dingPoolSize; i++) {
        const a = new Audio(this.audioMap.dingMusic);
        a.preload = 'auto';
        a.loop = false;
        this.dingAudios.push(a);
      }
    },
    playDing () {
      if (!this.dingAudios.length) this.initDingPool();
      const a = this.dingAudios[this.dingAudioIndex];
      this.dingAudioIndex = (this.dingAudioIndex + 1) % this.dingAudios.length;

      try { a.currentTime = 0; } catch (e) { }
      const p = a.play();
      // 必须吞掉 iOS 的拒绝，否则会影响主线程调度
      if (p && p.catch) p.catch(() => { });
    },
    // iOS/微信等环境，第一次用户点击时解锁（简单静音解锁）
    unlockDingOnIOS () {
      const ua = navigator.userAgent;
      const isIOS = /iP(hone|od|ad)/.test(ua);
      if (!isIOS) return;
      if (!this.dingAudios.length) this.initDingPool();
      const a = this.dingAudios[0];
      if (!a) return;

      // 已解锁则不重复
      if (this._dingUnlocked) return;

      try {
        a.muted = true;
        const p = a.play();
        if (p && p.catch) p.catch(() => { });
        setTimeout(() => {
          try {
            a.pause();
            a.currentTime = 0;
            a.muted = false;
            this._dingUnlocked = true;
          } catch (e) { }
        }, 50);
      } catch (e) { }
    },
    playDingWebAudio () {
      if (!this.dingReady || !this.audioCtx || !this.dingBuffer || !this.dingGain) return;
      if (this.audioCtx.state === 'suspended') {
        this.audioCtx.resume().catch(() => { });
        return;
      }
      const src = this.audioCtx.createBufferSource();
      src.buffer = this.dingBuffer;
      src.connect(this.dingGain);
      src.start(0);
    },
    startDingMetronome () {
      this.stopDingMetronome();

      this.dingLastSlot = -1;

      // 用 setInterval 把声音从 rAF 剥离出去
      this.dingIntervalId = setInterval(() => {
        if (!this.isSpinning) return;

        const idx = this.activeSlotIndex;
        if (idx === -1) return;

        // 只要格子变了，就叮一次（节拍器频率保证不会太密）
        if (idx !== this.dingLastSlot) {
          this.dingLastSlot = idx;
          if (this.isIOS && this.dingReady) this.playDingWebAudio();
          else this.playAudio('dingMusic');
        }
      }, this.dingTickMs);
    },

    stopDingMetronome () {
      if (this.dingIntervalId) {
        clearInterval(this.dingIntervalId);
        this.dingIntervalId = null;
      }
    },
    lanternClick (e) {
      // 点击次数
      const inner = e.currentTarget.querySelector('.lantern-inner')
      inner.classList.remove('btn-scale-ani') // 先移除，保证连点也能重新触发
      // 强制重绘，让浏览器认为是一次新的动画
      void inner.offsetWidth
      inner.classList.add('btn-scale-ani')

      inner.addEventListener('animationend', function handler () {
        inner.classList.remove('btn-scale-ani')
        inner.removeEventListener('animationend', handler)
      })

      this.playAudio('btnMusic');

      if (this.user_info.account === undefined || this.user_info.account === '') {
        this.changeLoginPopup(true);
        return
      }

      if (this.egg_cdk) return this.lanternEggPop = true;

      this.lanternClickCount += 1;

      // 每次点击都触发一次 lanternAni 动画（稳定重播）
      this.lanternAni = false;
      this.$nextTick(() => {
        // 强制回流，避免浏览器合并样式更新导致动画不重播
        if (this.$refs.lantern) this.$refs.lantern.offsetWidth;
        this.lanternAni = true;
      });

      // 33、66 次特殊处理
      if (this.lanternClickCount === 33 || this.lanternClickCount === 66) {
        this.onToastMessage("灯笼摇晃得更厉害了");
      }

      if (this.lanternClickCount < 100) {
        // console.log('click', this.lanternClickCount);
      } else {
        this.onGetCdk();
      }
    },
    onGetCdk () {
      Indicator.open();

      onGetCdkAPI()
        .then(response => {
          setTimeout(() => {
            Indicator.close();
            if (Number(response.code) === 200) {
              this.egg_cdk = response.data.cdk;

              this.lanternEggPop = true;
              this.getLoginContainer();
            } else {
              this.onToastMessage(response.message);
            }
          }, 400);
        }).catch((err) => {
          this.onToastMessage('服务器出错啦')
          Indicator.close();
        })
    },
    playClickAni (key, duration = 1000, sound = null) {
      // 动画期间禁止再次点击
      if (this.eggAniList[key]) return;
      // this.playAudio('btnMusic');


      // 开启动画class
      this.$set(this.eggAniList, key, true);

      // 播放音效
      this.playAudio(sound);

      // 到点复原
      clearTimeout(this.eggAniTimersList[key]);
      this.eggAniTimersList[key] = setTimeout(() => {
        this.$set(this.eggAniList, key, false);
      }, duration);
    },
    // 背景音乐点击事件
    musicClick (value, e) {
      this.playAudio('btnMusic');
      // this.triggerBtnScale(e);

      // 触发缩放（保证连点也能触发）
      this.isBtnScaling = false
      this.$nextTick(() => {
        this.isBtnScaling = true
        setTimeout(() => { this.isBtnScaling = false }, 250)
      })


      if (value) {
        // 只有用户主动点击“开启”时才允许重新播放
        this.userMutedBgm = false;
        this.isShowMusicBtn = true;
        this.playAudioBg('bgMusic');
        this.logger.sum('仙剑_春节h5_音效开启');
      } else {
        this.isShowMusicBtn = false;
        this.pauseAudio('bgMusic');
        this.logger.sum('仙剑_春节h5_音效关闭');
        // 记录用户已经手动关闭
        this.userMutedBgm = true;
      }
    },
    async initWebAudioDing () {
      if (this.dingReady) return;

      const AudioContext = window.AudioContext || window.webkitAudioContext;
      if (!AudioContext) return; // 极少数环境不支持

      if (!this.audioCtx) this.audioCtx = new AudioContext();

      // iOS 可能处于 suspended，需要 resume
      if (this.audioCtx.state === 'suspended') {
        try { await this.audioCtx.resume(); } catch (e) { }
      }

      // 拉取 mp3 并解码
      const resp = await fetch(this.audioMap.dingMusic);
      const arrBuf = await resp.arrayBuffer();
      this.dingBuffer = await this.audioCtx.decodeAudioData(arrBuf);
      this.dingReady = true;
    },
    playAudioBg (audioName) {
      if (this.userMutedBgm) return;

      if (!this.audioPlayers[audioName]) {
        this.audioPlayers[audioName] = new Audio(this.audioMap[audioName]);
        this.audioPlayers[audioName].loop = true;
        this.audioPlayers[audioName].volume = 1;
      }
      const p = this.audioPlayers[audioName].play();
      if (p && p.catch) p.catch(() => { });
    },
    pauseAudio (audioName) {
      if (this.audioPlayers[audioName]) {
        this.audioPlayers[audioName].pause();
      }
    },
    playAudio (audioName) {
      // 兼容旧调用：优先 WebAudio，没 buffer 就 fallback
      this.playSfx(audioName);
    },
    openDetailPop (e) {
      this.triggerBtnScale(e);
      this.playAudio('btnMusic');
      this.logger.sum('仙剑_春节h5_【活动详情】按钮');
      this.detailPop = true;
    },
    // 赠礼记录
    openRewardList (e) {
      this.triggerBtnScale(e);
      this.playAudio('btnMusic');
      this.logger.sum('仙剑_春节h5_【赠礼记录】按钮');

      if (this.user_info.account === undefined || this.user_info.account === '') {
        this.changeLoginPopup(true);
        return
      }

      this.rewardListPop = true;
    },
    // 任务页
    openTaskList (e) {
      this.triggerBtnScale(e);
      this.playAudio('btnMusic');
      this.logger.sum('仙剑_春节h5_【庆典谕章】按钮');

      if (this.user_info.account === undefined || this.user_info.account === '') {
        this.changeLoginPopup(true);
        return
      }

      this.taskListPop = true;
    },
    // 是否领取过奖励
    participatingTask (task_id, e, status) {

      if (this.user_info.account === undefined || this.user_info.account === '') {
        this.changeLoginPopup(true);
        return
      }

      // 任务状态为未完成
      if (!status) {
        this.triggerBtnScale(e);
        this.playAudio('btnMusic');
        // 每日登录游戏,任务二
        if (task_id == 2) {
          this.onToastMessage('登录游戏即可完成任务')
          this.logger.sum('仙剑_春节h5_任务统计-每日登录1次游戏');
        }
      }

      if (task_id == 3) {
        this.logger.sum('仙剑_春节h5_任务统计-邀请好友共饮');
        this.logger.sum('仙剑_春节h5_分享任务按钮');

        // 微信浏览器
        if (wechatBrowser() && /Mobile/i.test(navigator.userAgent)) {
          const url = new URL(window.location.href)
          url.searchParams.set('friend_id', this.userInfo.user_id)

          // 改地址栏
          window.history.replaceState(null, '', url.pathname + url.search)

          this.setShare({
            link: url.toString(), // 直接完整链接（带 https/http + 域名 + 参数）
            title: '挥剑问情丨葫芦已空，独酌难开',
            imgUrl: 'https://download4.qcplay.com/qcgame-api/ZxFJYG1AkoCM3BscErNHrCRqLtEv819DdbDZ0sJD.png',
            desc: '"策划"所藏佳酿需携侠友对饮！',
          })

          this.taskListPop = false
          this.shareShow = true
          this.logger.sum('仙剑_春节H5_微信引导遮罩')
        } else {
          this.taskListPop = false
          this.inviteFriendsShow = true
        }
      }
    },
    /** 点击开始 */
    handleClick (e) {
      // 2. 翻转中或旋转中，都不允许再次点击
      // console.log("this.isFlipping", this.isFlipping);
      // console.log("this.isSpinning", this.isSpinning);
      if (this.isFlipping || this.isSpinning) return

      // this.triggerBtnScale(e);
      const inner = e.currentTarget.querySelector('.start-btn-inner')
      inner.classList.remove('btn-scale-ani') // 先移除，保证连点也能重新触发
      // 强制重绘，让浏览器认为是一次新的动画
      void inner.offsetWidth
      inner.classList.add('btn-scale-ani')

      inner.addEventListener('animationend', function handler () {
        inner.classList.remove('btn-scale-ani')
        inner.removeEventListener('animationend', handler)
      })

      this.playAudio('btnMusic');

      // ⭐ 确保 iOS 已解锁（新增）
      this.unlockDingOnIOS();

      if (this.user_info.account === undefined || this.user_info.account === '') {
        this.changeLoginPopup(true);
        return
      }

      // 1. 没次数了，不能点
      if (this.drinkTimes <= 0) {
        this.onToastMessage('抽奖次数不足');
        return
      }

      lotteryDataAPI().then(response => {
        if (Number(response.code) === 200) {
          this.targetIndex = response.data.prize_id; //抽奖获得
          this.targetIndex == 9 ? this.logger.sum('仙剑_春节H5_定制称号领取次数') : this.logger.sum(`仙剑_春节H5_道具${this.targetIndex}领取次数`);
      // this.targetIndex = 9; //抽奖获得

      // 停止葫芦晃动
      this.isShake = false;

      // 3. 减少次数（带收缩动画）
      this.decreaseDrinkTimes();

      if (this.targetIndex == 9) {
        this.showGreenGourd = true;
        this.pauseAudio('bgMusic');
        this.isFlipping = true;

        // 3 秒后再执行盘面翻转逻辑
        setTimeout(() => {
          this.startCompassFlip();
        }, 3000);
      } else {
        this.startCompassFlip();
      }


          this.logger.sum('仙剑_春节h5_共饮次数');
          this.getLoginContainer();
          return
        }

        this.onToastMessage(response.message)
      }).catch((err) => {
        this.onToastMessage('服务器出错啦')
      })
    },
    startCompassFlip () {
      // 4. 触发盘面 180° 翻转
      this.playAudio('nianMusic');
      this.isFlipping = true;


      if (this.isFrontNow) {
        // 初始面 -> 翻出抽奖盘
        this.compassClass = ''
        this.$nextTick(() => {
          this.compassClass = 'compass-forward'
        })
      }
    },
    onAnimationStart (e) {
      // console.log("this.targetIndex:", this.targetIndex);

      const name = e.animationName

      if (name === 'compassBackward') return

      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      // 处理层级问题
      this.compassZIndexStyle = {
        zIndex: '9',
      }

      if (this.targetIndex == 9) {
        this.handleTarget9Flow();
      }

      const t = this.duration * (this.targetFrame / this.totalFrames);
      this.timer = setTimeout(() => {
        this.handleFrame13();
      }, t * 1000);
    },
    handleTarget9Flow () {
      // 初始状态
      Object.assign(this, {
        // showGreenGourd: true,
        corePopShow: true,
        lxyAni: false,
        lightShow: false,
        isHit: false
      });

      const timeline = [
        { delay: 500, action: () => { this.playAudio('lxyMusic') } },     // 独白
        { delay: 500, action: () => { this.lxyAni = true; } },            // 放大动画
        { delay: 6900, action: () => { this.playAudio('swordMusic') } },  // 剑声
        { delay: 6900, action: () => { this.lxyWhitePop = true; } },      // 白色蒙版显示
        { delay: 7000, action: () => { this.lightShow = true; } },        // 剑光显示
        { delay: 7300, action: () => { this.isHit = true; } },            // 转盘抖动
        { delay: 7200, action: () => { this.lxyAni = false; } },          // 放大人物隐藏
        { delay: 7200, action: () => { this.lxyAni02 = true; } },         // 带特效人物登场
        { delay: 7300, action: () => { this.lxyWhitePop = false; } },     // 白色蒙版隐藏
        { delay: 7300, action: () => { this.pointerState = 2; } },        // 年兽指针替换
        { delay: 7900, action: () => { this.lightShow = false; } },       // 剑光消失
      ];

      timeline.forEach(step => {
        setTimeout(step.action, step.delay);
      });
    },
    /** 盘面翻转动画结束 */
    handleAnimationEnd (e) {
      const name = e.animationName
      if (name !== 'compassForward' && name !== 'compassBackward') return

      if (name === 'compassForward') {
        // 180° 翻转已经完成
        this.isFrontNow = false
        this.isFlipping = false
        this.compassClass = 'compass-forward'

        setTimeout(() => {
          this.startSpin()
        }, 500)
      } else if (name === 'compassBackward') {
        this.isFrontNow = true
        this.isFlipping = false   // 允许下一次点击
        this.compassClass = 'compass-backward'     // 清理类名，停在最终帧
        this.pointerStyle = {
          transform: 'translate(-50%, -50%) rotate(0deg)',
        }
        // 处理层级问题
        this.compassZIndexStyle = {
          zIndex: '2'
        }
        this.isHit = false;
        this.playAudioBg('bgMusic');
      }
    },
    handleFrame13 () {
      this.pointerState = 1;
    },
    // 减少次数时调用
    decreaseDrinkTimes () {
      if (this.drinkTimes <= 0) return

      this.isDecreasing = true

      setTimeout(() => {
        // this.drinkTimes -= 1
        this.isDecreasing = false
      }, 300)
    },
    /** 中心指针旋转逻辑：从快到慢，随机停在某一格 */
    startSpin () {
      if (this.isSpinning) return
      this.isSpinning = true

      // ⭐ 每次开始旋转重置 ding 触发状态（新增）
      this.lastDingIndex = -1;
      this.lastDingAt = 0;

      // 核心奖励
      if (this.targetIndex == 9) {
        setTimeout(() => {
          this.onSpinEnd(9)
        }, 9400)
        return;
      }

      const turns = 4; // 转的圈数
      const duration = 3.5 // 秒（旋转时长）

      // 1. 每次从 0deg 开始，避免累积误差
      this.pointerStyle = {
        transform: 'translate(-50%, -50%) rotate(0deg)',
        transition: 'none',
      }

      this.$nextTick(() => {
        // 2. 计算目标角度：多转几圈 + 第 targetIndex 格中心
        const centerAngle = this.baseOffset + (this.targetIndex - 1) * this.sectorAngle;
        const targetAngle = turns * 360 + centerAngle - 10;

        // 2) 开始指针旋转
        this.pointerStyle = {
          transform: `translate(-50%, -50%) rotate(${targetAngle}deg)`,
          transition: `opacity 0.5s ease, transform ${duration}s cubic-bezier(0.12, 0.72, 0.26, 1)`
        };

        // this.playAudio('pointer');

        // ⭐ 新增光圈：根据 DOM 实际角度实时更新高亮
        // this.startPointerTracking(duration);
        this.startPointerTracking(duration, targetAngle);

        // 动画结束回调
        setTimeout(() => {
          this.isSpinning = false;
          this.stopDingMetronome();
          this.playAudio('redeemMusic');

          setTimeout(() => {
            this.pointerState = 0;
          }, 100)

          // 再读一次最终角度，防止浮点误差
          const pointerEl = this.$el.querySelector('.compass-pointer');
          let finalAngle = 0;
          if (pointerEl) {
            finalAngle = this.getCurrentPointerAngle(pointerEl);
            this.activeSlotIndex = this.angleToIndex(finalAngle);
          } else {
            this.activeSlotIndex = this.targetIndex - 1;
          }

          // console.log('对应位置 index =', this.activeSlotIndex)

          // 这里可以触发抽奖结果弹窗等逻辑
          this.onSpinEnd(this.activeSlotIndex)
        }, duration * 1000)
      });
    },
    makeCubicBezier (p1x, p1y, p2x, p2y) {
      const cx = 3 * p1x;
      const bx = 3 * (p2x - p1x) - cx;
      const ax = 1 - cx - bx;

      const cy = 3 * p1y;
      const by = 3 * (p2y - p1y) - cy;
      const ay = 1 - cy - by;

      const sampleCurveX = (t) => ((ax * t + bx) * t + cx) * t;
      const sampleCurveY = (t) => ((ay * t + by) * t + cy) * t;
      const sampleDerivX = (t) => (3 * ax * t + 2 * bx) * t + cx;

      const solveCurveX = (x) => {
        let t2 = x;
        for (let i = 0; i < 8; i++) {
          const x2 = sampleCurveX(t2) - x;
          if (Math.abs(x2) < 1e-6) return t2;
          const d2 = sampleDerivX(t2);
          if (Math.abs(d2) < 1e-6) break;
          t2 = t2 - x2 / d2;
        }
        let t0 = 0, t1 = 1;
        t2 = x;
        while (t0 < t1) {
          const x2 = sampleCurveX(t2);
          if (Math.abs(x2 - x) < 1e-6) return t2;
          if (x > x2) t0 = t2;
          else t1 = t2;
          t2 = (t1 - t0) * 0.5 + t0;
        }
        return t2;
      };

      return (x) => sampleCurveY(solveCurveX(x));
    },
    startPointerTracking (duration, targetAngle) {
      const startTime = performance.now();
      const pointerEl = this.$el.querySelector('.compass-pointer');
      if (!pointerEl) return;

      this.showHighlight = true;

      // 重置叮声状态
      this.lastDingIndex = -1;
      this.lastDingAt = 0;

      // cubic-bezier(0.12, 0.72, 0.26, 1) 的 JS 版本（只用于后半段）
      const ease = this.makeCubicBezier(0.12, 0.72, 0.26, 1);

      const loop = (now) => {
        if (!this.isSpinning) return;

        const elapsed = (now - startTime) / 1000;
        let t = elapsed / duration;
        if (t > 1) t = 1;

        let idx = -1;

        // ⭐ 前半段用 DOM 读角度，后半段用时间计算角度（慢速不漏）
        if (t < 0.6) {
          const angle = this.getCurrentPointerAngle(pointerEl);
          idx = this.angleToIndex(angle);
        } else {
          const p = ease(t);
          const currentAngle = targetAngle * p;
          idx = this.angleToIndex(currentAngle);
        }

        this.activeSlotIndex = idx;

        // ⭐ 后半段更慢，允许更密一些，避免漏叮
        const nowMs = Date.now();
        const gap = (t < 0.6) ? this.dingMinGap : 40; // 慢速阶段 30~50 之间最稳
        if (idx !== this.lastDingIndex && (nowMs - this.lastDingAt) >= gap) {
          this.lastDingIndex = idx;
          this.lastDingAt = nowMs;
          this.playDing();
        }

        if (t < 1) {
          requestAnimationFrame(loop);
        } else {
          // 结束强制对齐最终格子
          const finalIdx = this.angleToIndex(targetAngle);
          this.activeSlotIndex = finalIdx;
          // 最后一声确保有
          const endMs = Date.now();
          if (finalIdx !== this.lastDingIndex && (endMs - this.lastDingAt) >= 20) {
            this.lastDingIndex = finalIdx;
            this.lastDingAt = endMs;
            this.playDing();
          }
        }
      };

      requestAnimationFrame(loop);
    },
    // 从 DOM 的 transform 里解析当前 rotate 角度（deg）
    getCurrentPointerAngle (el) {
      const style = window.getComputedStyle(el);
      const transform = style.transform || style.webkitTransform;

      if (!transform || transform === 'none') return 0;

      // 情况1：matrix(a, b, c, d, e, f)
      const matrixMatch = transform.match(/matrix\(([^)]+)\)/);
      if (matrixMatch && matrixMatch[1]) {
        const parts = matrixMatch[1].split(',');
        const a = parseFloat(parts[0]);
        const b = parseFloat(parts[1]);
        const angle = Math.atan2(b, a) * (180 / Math.PI); // -180~180
        return angle;
      }

      // 情况2：rotate(XXXdeg)
      const rotateMatch = transform.match(/rotate\(([-\d.]+)deg\)/);
      if (rotateMatch && rotateMatch[1]) {
        return parseFloat(rotateMatch[1]);
      }

      return 0;
    },
    angleToIndex (angle) {
      const total = this.prizeCount; // 8
      // 归一化到 0~360
      let a = ((angle % 360) + 360) % 360;

      // ⭐ 角度微调：补偿 iOS 读取滞后/指针素材非正北
      a = (a + this.highlightAngleFix + 360) % 360;

      // 减去基准偏移
      let relative = a - this.baseOffset;

      // 归一化 relative 到 0~360
      relative = ((relative % 360) + 360) % 360;

      // ⭐ 用 floor + 半格偏移：稳定落在“当前扇区”
      // half = 22.5°，让边界抖动时不容易跳错格
      const half = this.sectorAngle / 2; // 22.5
      const idx = Math.floor((relative + half) / this.sectorAngle) % total;

      return idx; // 0~7
    },

    clearHighlightLoop () {
      if (this.spinTimer) {
        clearInterval(this.spinTimer)
        this.spinTimer = null
      }
    },
    /** 旋转结束回调：这里处理中奖逻辑 */
    onSpinEnd (index) {
      this.stopDingMetronome();

      const prize = this.slotList[index]
      // console.log('停在第', index, '格，奖品：', prize)

      // this.currentPrizeText = prize.text || `第 ${index + 1} 格`

      //  2. 触发盘面翻回去
      if (!this.isFrontNow && !this.isFlipping) {
        this.isFlipping = false
        this.compassClass = 'compass-backward'
        // ⭐ 归位时关掉高亮
        this.showHighlight = false;
        this.activeSlotIndex = -1;
        this.lxyAni = false;
        this.lxyAni02 = false;
        this.lightShow = false;
        this.showGreenGourd = false;
        this.corePopShow = false;
        this.isSpinning = false
        setTimeout(() => {
          this.pointerState = 0;
        }, 100)
      }

      if (this.targetIndex == 9) {
        this.compassRewardLimitPop = true
      } else {
        setTimeout(() => {
          this.compassRewardPop = true;
        }, 500)
      }
    },
    clickTyrEgg () {
      this.playAudio('btnMusic');
      if (this.user_info.account === undefined || this.user_info.account === '') {
        this.changeLoginPopup(true);
        return
      }

      this.tyrEggPop = true;
    },
    closeDetailPop () {
      this.playAudio('btnMusic');
      this.detailPop = false;
    },
    closeRewardPop () {
      this.playAudio('btnMusic');
      this.compassRewardPop = false;
      // 开始葫芦晃动
      this.isShake = true;
    },
    closeRewardListPop () {
      this.playAudio('btnMusic');
      this.rewardListPop = false;
    },
    closeTaskListPop () {
      this.playAudio('btnMusic');
      this.taskListPop = false;
    },
    closeRewardLimitPop () {
      this.playAudio('btnMusic');
      this.compassRewardLimitPop = false;
      // 开始葫芦晃动
      this.isShake = true;
    },
    closeInvitePop () {
      this.playAudio('btnMusic');
      this.inviteFriendsShow = false;
    },
    closeSharePop () {
      this.playAudio('btnMusic');
      this.shareShow = false;
      const newUrl = `${window.location.pathname}`
      window.history.replaceState(null, '', newUrl);
    },
    closeHelpPop () {
      this.playAudio('btnMusic');
      this.helpShow = false;
    },
    closeTyrEggPop () {
      this.playAudio('btnMusic');
      this.tyrEggPop = false;
    },
    closeLanternEggPop () {
      this.playAudio('btnMusic');
      this.lanternEggPop = false;
    },
    // 适配
    forceLandscapeScreenHandle () {
      if (document.activeElement.nodeName === "INPUT") return; // 兼容安卓
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      var docEl = document.documentElement,
        fontH = window.innerWidth > window.innerHeight ? height : width;

      const el = document.getElementById("springFestival-home-page");
      let style = "";
      if (width < height) {
        // 竖版
        style = `transform:rotate(90deg);transform-origin:${width / 2
          }px center;width:${height}px;height:${width}px`;
        this.onAdapt(1);
      } else {
        // 横板
        setTimeout(() => {
          document.documentElement.style.fontSize = (75 * fontH) / 750 + "px";
          style = `transform:rotate(0deg);transform-origin:${width / 2
            }px center;width:${width}px;height:${height}px`;
          if (el) el.style = style;
        }, 300);
        this.onAdapt(2);
      }
      document.getElementsByTagName(
        "body"
      )[0].style = `width:${width}px;height:${height}px;font-size:${(75 * fontH) / 750
      }px;`;
      if (el) el.style = style;
    },
    onWindowSizeChanged () {
      window.addEventListener("resize", this.forceLandscapeScreenHandle);
    },
    isReloadWindow (event) {
      return (
        !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) &&
        ((event && event.persisted) ||
          (window.performance &&
            window.performance.navigation &&
            window.performance.navigation.type === 2))
      );
    },
    startLoading () {
      // 防止第二次进入 微信底部有一个返回条，造成布局问题
      if (this.isReloadWindow()) {
        window.location.reload();
        return;
      }
    },
    //小屏自适应 type 1竖屏 2横屏
    onAdapt (type) {
      const width = document.documentElement.clientWidth;
      const height = document.documentElement.clientHeight;
      const aspectRatio = Number((width / height).toFixed(3));
      // console.log("aspectRatio", aspectRatio);
      // 竖屏大于0.6就要缩小0.83
      // 横屏小于1.7就要缩小 1.48缩小0.85 1.3缩小0.75  大于2.16就是横屏太长，换背景
      // if (type == 1) {
      //   this.isLong = false;
      //   if (aspectRatio >= 0.63) {
      //     this.scaleStyle = "transform-origin: right;transform: scale(0.83);";
      //   } else {
      //     this.scaleStyle = "transform-origin: right;transform: scale(1);";
      //   }
      // } else {
      //   if (aspectRatio < 1.7 && aspectRatio >= 1.48) {
      //     this.scaleStyle = "transform-origin: right;transform: scale(0.85);";
      //     this.isLong = false;
      //   } else if (aspectRatio < 1.48 && aspectRatio >= 1.3) {
      //     this.scaleStyle = "transform-origin: right;transform: scale(0.75);";
      //     this.isLong = false;
      //   } else if (aspectRatio > 2.16) {
      //     this.scaleStyle = "transform-origin: right;transform: scale(1);";
      //     this.isLong = true;
      //   } else {
      //     this.scaleStyle = "transform-origin: right;transform: scale(1);";
      //     this.isLong = false;
      //   }
      // }
    },
    // 初始化
    getLoginContainer () {
      Indicator.open();
      onGetInitDataAPI()
        .then((response) => {
          if (Number(response.code) == 200) {
            this.active_Info = response.data.activity || [];
            this.user_info = response.data.user_info || [];
            this.taskList = response.data.activity.task_info;  // 任务列表
            this.rewardList = response.data.activity.record_list;  // 赠礼记录
            this.drinkTimes = response.data.activity.times; // 剩余抽奖次数
            this.egg_cdk = response.data.activity.cdk; // 彩蛋cdk
            // console.log("this.drinkTimes:", this.drinkTimes);

            // 回调
            this.onInitDataCallback(response);
            this.setUserInfo(response.data.user_info);
            return;
          }
          // 登录异常
          Number(response.code) !== 401 && this.onToastMessage(response.message)
        })
        .finally(() => {
          Indicator.close();
        });
    },
    // 好友助力
    friendHelp () {
      if (this.user_info.account === undefined || this.user_info.account === '') {
        this.changeLoginPopup(true);
        return
      }
      if (this.friendId) {
        this.helpShow = true;
      }
    },
    // 接受邀请
    acceptInvitationBtn () {
      this.logger.sum('仙剑_春节h5_助力按钮统计');
      assistanceDataAPI({ help_id: this.friendId }).then((res) => {
        if (res.code === 200) {
          const currentUrl = window.location.href;
          const baseUrl = currentUrl.split('?')[0];
          window.history.replaceState({}, '', baseUrl);
          this.helpShow = false;
          this.friendId = '';
          this.onToastMessage('共饮成功~');
          this.logger.sum('仙剑_春节h5_成功助力次数');
        } else {
          this.onToastMessage(res.message);
        }
      })
    },
    onCopyCDK () {
      this.playAudio('btnMusic');

      const clipboard = new Clipboard("#clipboard-cdk-btn");
      clipboard.on("success", (e) => {
        this.onToastMessage('复制成功');
        e.clearSelection();
      });
      clipboard.on("error", (e) => {
        this.onToastMessage('复制失败');
      });
      this.logger.sum("仙剑春节转盘_复制兑换码");
    },
    onCopyEgg () {
      this.playAudio('btnMusic');

      const clipboard = new Clipboard("#clipboard-egg-btn");
      clipboard.on("success", (e) => {
        this.onToastMessage('复制成功');
        e.clearSelection();
      });
      clipboard.on("error", (e) => {
        this.onToastMessage('复制失败');
      });
      this.logger.sum("仙剑春节转盘_复制唐雨柔彩蛋文字密令");
    },
    // 复制链接
    onCopy () {
      this.playAudio('btnMusic');

      const clipboard = new Clipboard("#clipboard-btn");
      clipboard.on("success", (e) => {
        this.onToastMessage('已成功复制分享链接');
        e.clearSelection();
      });
      clipboard.on("error", (e) => {
        this.onToastMessage('复制失败');
      });
      this.logger.sum("仙剑春节转盘_复制链接按钮");
    },
    // 退出登录
    logout () {
      onLogoutAPI({ game_id: this.userInfo.game_id }).then((res) => {
        this.logoutShow = false;
        if (res.code === 200) {
          // 清空数据 控制弹窗
          window.localStorage.setItem("access_token", "");
          this.osCancell();
          this.setInitUserInfo();
          this.setInitActiveInfo();
          this.changeLoginPopup(true);
        } else {
          this.onToastMessage(res.msg);
        }
      });
    },
    selectCallback () {
      this.getLoginContainer();
    },
    osCancell () {
      // 清空数据
      // this.getLoginContainer();
      this.clearActiveInfo();
    },
    // 清除data里面相关数据
    clearActiveInfo () {
      this.active_Info = [];
      this.user_info = [];
      this.egg_cdk = '';
      this.friendId = '';
      this.urlToken = '';
      this.cachedToken = '';
      this.isShake = true;
      this.isFront = true;
      this.isFrontNow = true;
      this.isFlipping = false;
      this.isAnimating = false;
      this.compassClass = '';
      this.drinkTimes = 0;
      this.isDecreasing = false;
      this.showGreenGourd = false;
      this.lxyAni = false;
      this.lightShow = false;
      this.corePopShow = false;
      this.isHit = false;
      this.rewardList = [];
      this.taskList = [];
      this.targetIndex = 0;
      this.pointerState = 0;
      this.isSpinning = false;
      this.baseOffset = 0;
      this.pointerOffset = 0;
      this.pointerStyle = {
        transform: 'translate(-50%, -50%) rotate(0deg)',
      };
      this.compassZIndexStyle = {
        zIndex: '2'
      };
      this.currentAngle = 0;
      this.finalAngle = 0;
      this.activeSlotIndex = -1;
      localStorage.setItem('hjwq_sf_token', '');
    },
    // 打开登陆弹窗
    openLoginOS (e) {
      this.triggerBtnScale(e);
      this.playAudio('btnMusic');

      // 未登录 --> 登录
      if (!this.userInfo.role_id) {
        this.changeLoginPopup(true);
        return;
      }

      // 已登录 --> 区分 切换 / 注销
      if (this.userInfo.platform === 'android' || this.userInfo.platform === 'ios') {
        // 切换
        this.friendId = '';
        this.changeOsPopup(true);     // 原来的“切换端”弹窗
      } else {
        // 注销
        this.logout();         // 或直接调用注销方法
      }
    },
    // TAG: 其他简易封装的方法
    onToast (config) {
      const curConfig = {
        duration: 1000000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    isSetShare () {
      const { protocol, host } = window.location;
      const enterLink = `${protocol}//${host}/hjwq/springFestival/enter${getRandomString()}`;
      this.setShare({
        link: enterLink,
        title: '挥剑问情丨葫芦已空，独酌难开',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/ZxFJYG1AkoCM3BscErNHrCRqLtEv819DdbDZ0sJD.png',
        desc: '"策划"所藏佳酿需携侠友对饮！',
      })
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "confirmLogout",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup",
    ]),
    ...mapActions(["onInitDataCallback", "setShare"]),
  },
  beforeDestroy () {
    if (this.timer) clearTimeout(this.timer);
  }
}
</script>

<style lang="less" scope>
@import url("./index.less");

.five_dimensions {
  div {
    width: 100% !important;
    height: 100% !important;

    canvas {
      width: 100% !important;
      height: 100% !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/hjwq/springFestival/index/index.vue